import { render, staticRenderFns } from "./ChangeColorConfig.vue?vue&type=template&id=097bebc7&scoped=true"
import script from "./ChangeColorConfig.vue?vue&type=script&lang=ts"
export * from "./ChangeColorConfig.vue?vue&type=script&lang=ts"
import style0 from "./ChangeColorConfig.vue?vue&type=style&index=0&id=097bebc7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bebc7",
  null
  
)

export default component.exports